import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import MainLogo from "../brand/MainLogo";
import RonaWalkLogo from "../brand/RonaWalkLogo";
import GoldenPathLogo from "../brand/GoldenPathLogo";
import { SEASONS, STORY_WALK, WALK_TAGLINE } from "../brand/tokens";

const WalkPage = () => {
  const loc = useLocation();

  useEffect(() => {
    if (loc.hash) {
      const el = document.querySelector(loc.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 250);
    }
  }, [loc]);

  return (
    <main className="site-main" data-testid="page-walk">
      <section className="walk-hero">
        <div className="walk-hero__logo">
          <RonaWalkLogo size={520} />
        </div>
        <p className="eyebrow">THE RONA WALK · A LIFESTYLE MOVEMENT</p>
        <h1><em>{WALK_TAGLINE}.</em></h1>
        <p className="lede">{STORY_WALK.lines[3]}</p>
      </section>

      <section className="walk-tips">
        <div className="section__head">
          <p className="eyebrow">HEALTHY WALKING · GENTLE RULES</p>
          <h2>How to walk the Rona way.</h2>
        </div>
        <div className="walk-tips__grid">
          {STORY_WALK.tips.map((tip, i) => (
            <div className="walk-tip" key={i} data-testid={`walk-tip-${i}`}>
              <span className="walk-tip__num">0{i + 1}</span>
              <p>{tip}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="walk-seasons">
        <div className="section__head">
          <p className="eyebrow">SEASONAL COLLECTIONS</p>
          <h2>A walk for every season.</h2>
          <p className="lede">The Rona Walk is represented through five seasonal themes — one tree, five seasons, five voices.</p>
        </div>

        <div className="walk-symbols" data-testid="walk-symbols">
          <div className="walk-symbols__head">
            <p className="eyebrow">SYMBOLS OF THE WALK</p>
            <h3>Every element carries a meaning.</h3>
          </div>
          <div className="walk-symbols__grid">
            <div className="walk-symbol" data-testid="symbol-tree">
              <span className="walk-symbol__label">🌳 Tree</span>
              <p>Growth & Healing</p>
            </div>
            <div className="walk-symbol" data-testid="symbol-path">
              <span className="walk-symbol__label">🛤️ Path</span>
              <p>The Wellness Journey</p>
            </div>
            <div className="walk-symbol" data-testid="symbol-roots">
              <span className="walk-symbol__label">🌿 Roots</span>
              <p>Grounding & Strength</p>
            </div>
            <div className="walk-symbol" data-testid="symbol-circle">
              <span className="walk-symbol__label">⭕ Circle</span>
              <p>Community, Wholeness & Connection</p>
            </div>
            <div className="walk-symbol" data-testid="symbol-sunrise">
              <span className="walk-symbol__label">🌅 Sunrise</span>
              <p>Hope & Renewal</p>
            </div>
          </div>
        </div>

        <div className="walk-seasons__list">
          {SEASONS.map((s, i) => (
            <article
              className={`walk-season ${i % 2 === 1 ? "walk-season--alt" : ""}`}
              id={s.id}
              key={s.id}
              data-testid={`walk-season-${s.id}`}
            >
              <div className="walk-season__visual">
                <div className="walk-season__frame" style={{ borderColor: s.accent }}>
                  <MainLogo size={260} />
                </div>
                <span className="walk-season__accent-dot" style={{ background: s.accent }} />
              </div>
              <div className="walk-season__meta">
                <p className="eyebrow" style={{ color: s.accent }}>{s.theme.toUpperCase()}</p>
                <h3>{s.name}</h3>
                <p className="walk-season__title">{s.title}</p>
                <p className="walk-season__message">{s.message}</p>
                <div className="walk-season__facts">
                  <div><strong>Icon</strong><span>{s.treeState}</span></div>
                  <div><strong>Events</strong><span>{s.events}</span></div>
                  <div><strong>Community</strong><span className="walk-season__hashtag">{s.hashtag}</span></div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="walk-cta">
        <GoldenPathLogo size={520} showTagline={true} withFrame={false} />
        <p className="walk-cta__quote"><em>{STORY_WALK.close}</em></p>
      </section>
    </main>
  );
};

export default WalkPage;
